export function pickPackagingAssessmentProse(params: {
  en: string | undefined
  zh: string | undefined
  legacy?: string
  useChinese: boolean
}): string {
  if (params.useChinese && params.zh != null && params.zh.trim().length > 0) {
    return params.zh
  }
  if (params.en != null && params.en.trim().length > 0) {
    return params.en
  }
  if (params.legacy != null && params.legacy.trim().length > 0) {
    return params.legacy
  }
  return ''
}

export function pickPackagingAssessmentProseList(params: {
  en: string[] | undefined
  zh: string[] | undefined
  legacy?: string[]
  useChinese: boolean
}): string[] {
  if (params.useChinese && params.zh != null && params.zh.length > 0) {
    return params.zh
  }
  if (params.en != null && params.en.length > 0) {
    return params.en
  }
  return params.legacy ?? []
}
